import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/esm/objectWithoutPropertiesLoose';
import React from 'react';
import { Text } from '@trybeapp/ui.text';

var _excluded = ["currency", "locale", "showDecimals", "amount", "as"];
var Money = function Money(_ref) {
  var _ref$currency = _ref.currency,
    currency = _ref$currency === void 0 ? 'GBP' : _ref$currency,
    _ref$locale = _ref.locale,
    locale = _ref$locale === void 0 ? 'en-GB' : _ref$locale,
    _ref$showDecimals = _ref.showDecimals,
    showDecimals = _ref$showDecimals === void 0 ? true : _ref$showDecimals,
    amount = _ref.amount,
    _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'span' : _ref$as,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var formatted = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency.toUpperCase()
  }).format(amount);
  if (showDecimals === false) {
    var decimalSeparator = new Intl.NumberFormat(locale).format(1.11).match(/[^1]/)[0];

    // Match on the decimal separator followed by one or more digits and white space
    var decimalsRegex = new RegExp("\\" + decimalSeparator + "\\d+(\\s)?");

    // Replace the decimal separator, decimals and the white space with just the white space
    formatted = formatted.replace(decimalsRegex, '$1');
  }
  return /*#__PURE__*/React.createElement(Text, _extends({
    as: as
  }, props), formatted);
};
Money.defaultProps = {
  currency: 'GBP',
  locale: 'en-GB',
  showDecimals: true
};

export { Money };
